import "./contact.css";
import { Link } from "react-router-dom";
import contactImg from "../../assets/img/home/asset 4.jpeg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Contact = () => {
	return (
		<section className="contact">
			<div className="container">
				<div className="img-holder">
					<img src={contactImg} alt="about-img" />
				</div>
				<div className="text-zone">
					<span className="sub-title">Kontakt</span>
					<h1 className="title">Haben Sie Fragen?</h1>
					<p className="desc">
						Nehmen Sie gerne mit uns Kontakt auf. Wir freuen uns, Ihnen all Ihre
						Fragen beantworten zu können.
					</p>
					<ul className="contacts-list">
						<div className="top">
							<li className="contact-item">
								<i className="icon t-3">
									<LocalPhoneIcon />
								</i>
								<div className="info">
									<h4 className="ttl">Telefon & Fax</h4>
									<a className="" href="tel:05646 943182">
										Tel.: 05646 943182
									</a>
									<span>Fax.: 05646 943098</span>
								</div>
							</li>
							<li className="contact-item">
								<i className="icon t-3">
									<EmailIcon />
								</i>
								<div className="info">
									<h4 className="ttl">E-Mail</h4>
									<a
										className="mailto:info@mobilepflege-petker.de"
										href="tel:05646 943182"
									>
										info@mobilepflege-petker.de
									</a>
								</div>
							</li>
						</div>
						<div className="bottom">
							<li className="contact-item">
								<i className="icon t-3">
									<LocationOnIcon />
								</i>
								<div className="info">
									<h4 className="ttl">Adresse</h4>
									<span>Auf den Ängern 5, 34439 Willebadessen</span>
								</div>
							</li>
							<li className="contact-item">
								<i className="icon t-3">
									<AccessTimeIcon />
								</i>
								<div className="info">
									<h4 className="ttl">Telefonzeiten</h4>
									<span>Mo-Do: 08:00-16:00</span>
									<span>Fr: 08:00-13:00</span>
								</div>
							</li>
						</div>
					</ul>
					<Link to="/" className="main-btn t-3">
						Kontakt aufnehmen
					</Link>
				</div>
			</div>
		</section>
	);
};

export default Contact;
